import * as React from "react";
import { oneMoreWords } from "../../../../../../utils/string";
import { CommentStarForM } from "../../CommentStar";
import { StarAndSoldLine, LeftStarNum, RightSold } from "./styles";
export const StarAndSold = (props) => {
    const { star = 0, sold } = props;
    return (React.createElement(StarAndSoldLine, null,
        !!star && (React.createElement(CommentStarForM, { rateScore: star },
            React.createElement(LeftStarNum, null, oneMoreWords(star.toString())))),
        React.createElement(RightSold, { hasStar: !!star }, sold)));
};
